export const routesTerminal = [
  {
    path: "/terminal_kullanici",
    name: "terminal_kullanici",
    component: () => import("@/views/terminal/terminal_kullanici/index.vue"),
    meta: {
      public: false,
      title: "terminal.Terminal Kullanıcı",
      yetki: { k: [1060102] },
    },
  },
  {
    path: "/terminal_log",
    name: "terminal_log",
    component: () => import("@/views/terminal/terminal_log/index.vue"),
    meta: {
      public: false,
      title: "terminal.Terminal Log",
      yetki: { k: [1060202] },
    },
  },
]
